module.exports = __webpack_public_path__ + "img/Weapon_164.c10561d3.png";